import $ from 'jquery';
import 'slick-carousel';

export default function HeroSlider() {
  // ===== HERO SLIDER =====
  const $slider = $('.js-hero-slider');
  if ($slider.length) {
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    });
  }

  // ===== UPCOMING EVENTS SLIDER =====
  const $grid = $('#events-grid .grid-wrap');
  if (!$grid.length) return; // safety guard

  // create nav container once (for below-slider arrows)
  const $navContainer = $('<div class="slider-nav"></div>');
  $('#events-grid').append($navContainer);

  function initUpcomingSlider() {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (isMobile) {
      if (!$grid.hasClass('slick-initialized')) {
        $grid.css('display', 'block');

        $grid.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          appendArrows: $navContainer, // arrows below slider
          dots: false,
          infinite: true,
          adaptiveHeight: true,
          prevArrow: `
            <button type="button" class="slick-prev" aria-label="Previous">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M7.65 14L32 14L32 18L7.65 18L18.85 29.2L16 32L0 16L16 0L18.85 2.8L7.65 14Z" fill="#F68B21"/>
              </svg>
            </button>
          `,
          nextArrow: `
            <button type="button" class="slick-next" aria-label="Next">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M24.35 18L0 18L0 14L24.35 14L13.15 2.8L16 0L32 16L16 32L13.15 29.2L24.35 18Z" fill="#F68B21"/>
              </svg>
            </button>
          `,
        });

      }
    } else if ($grid.hasClass('slick-initialized')) {
      $grid.slick('unslick');
      $grid.css('display', '');
      $navContainer.empty(); // clear nav buttons when reverting
    }
  }

  // Run on load
  initUpcomingSlider();

  // Debounce resize for performance
  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initUpcomingSlider, 250);
  });
}
